import { render, staticRenderFns } from "./view-all-link.vue?vue&type=template&id=4d6d31b6"
import script from "./view-all-link.vue?vue&type=script&lang=js"
export * from "./view-all-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports